'use strict';

import { Component } from 'react';
import { CourseStatus } from './course-status';
import connectCourseStatus from './connectCourseStatus';

export class CourseStatusFilter extends Component {
	render() {
		const { current_refinement = CourseStatus.All, refine, has_in_progress, has_completed } = this.props;
		const has_active_filter = CourseStatus.All !== current_refinement;
		
		if (! has_in_progress && ! has_completed && ! has_active_filter) {
			return null;
		}
		
		const options = [CourseStatus.All, CourseStatus.NotStarted];
		
		if (has_in_progress) {
			options.push(CourseStatus.InProgress);
		}
		
		if (has_completed) {
			options.push(CourseStatus.Completed);
		}
		
		if (has_active_filter && ! options.includes(current_refinement)) {
			options.push(current_refinement);
		}
		
		return (
			<div className="mb-4">
				<h4 className="mt-8 mb-1">My Courses</h4>
				<p className="m-0">Filter courses by your progress.</p>
				<div className="flex flex-col mt-2">
					{ options.map(option => (
						<label key={ option } className="flex gap-2 items-center py-0.5 text-xs font-semibold text-gray-600 cursor-pointer">
							<input
								type="radio"
								name="course-status"
								className="m-0"
								checked={ current_refinement === option }
								onChange={ () => refine(option) }
							/>
							{ option }
						</label>
					)) }
				</div>
			</div>
		);
	}
}

export default connectCourseStatus(CourseStatusFilter);
